module.exports = __webpack_public_path__ + "static/media/ser_esb_net_not.4a9f62da.png";